import React, { useEffect, useRef, useState } from 'react';
import { Badge, Col, Form, message, Row, Spin, Tabs, } from 'antd';
import ProForm, { ProFormInstance } from '@ant-design/pro-form';
import { FileUploadUtility, WdiFileList } from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import { FormPageProps, WdiFormPageTitle } from '@/components/WdiBus/FormPage';
import { initApprovalPageContext, ViewEntityProps } from '../../components/data';
import { ResponseStatus } from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import { DataOptions } from '@/services/basic/metadata';
import DynamicInformation from '../../components/DynamicInformation';
import FormSaInfosApp from '../../../sa/components/FormSaInfos';
import { Enum } from '@/enums/system';
import { WdiPanel } from '@/components/WdiControls/WdiPanel';
import { WdiCardTitle, WdiStaffCard } from '@/components/WdiControls';
import {
  GeneralSettleDetailsForApprovalApp,
  GeneralSettleDetailsGroupForApprovalApp
} from '../../GeneralSettleApply/components/details';
import { SsWarningApprovalApp } from "@/pages/sales/ss/components/SsWarningInformation";
import { FormApi } from "@/services/sales";
import TextArea from "antd/lib/input/TextArea";
import { FormSa } from "@/services/sales/sa";
import SalesAndCostPanel from "@/pages/sales/sa/components/SalesAndCostCurrent";
import { StatusEnum } from "@/enums/status";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }, {
      url: "/expenseapi/ssButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "PendingButton",
        "PaymentButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        "TransferNodeButton",
        "ViewSfaCollectionDetailsButton",
        "FormSpPrintButton",
        "AddMailApproverButton",
        "ExpediteFlowButton",
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/ssButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

const approvalConfig: any = {
  params: {
    url: "/expenseapi/ssButtons/get",
    keys: [
      "ApprovalButton",
      "ReadButton",
    ]
  }
};

const GeneralSettleApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [warningCount, setWarningCount] = useState<number>(0);
  const [salesDataSource, setSalesDataSource] = useState<any[]>([]);
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [!!(formRef?.current)])

  const onDetailsChange = (data: any[]) => {
    setDataSource(data);
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;

        setEntity(viewEntity);

        const warningCountResult = await FormApi.getFormWarningCount(viewEntity?.form?.formId ?? 0);
        setWarningCount(warningCountResult.data)

        if (viewEntity.formSs) {
          formRef.current?.setFieldsValue({
            remark: viewEntity.formSs.remark,
            differenceDesc: viewEntity.formSs.differenceDesc,
            fileInfo: FileUploadUtility.parse(viewEntity.formSs.fileName, viewEntity.formSs.filePath),
          });
          if (viewEntity.formSs.settleMaterial) {
            formRef.current?.setFieldsValue({
              settleMaterial: viewEntity.formSs.settleMaterial.split(',')
            });
          }
          if (viewEntity.form?.statusId == StatusEnum.FormStatus.AWAITING) {
            await handleSubmit(Number(viewEntity.formSs.formSaId));
          }
        }

        if (viewEntity.formSsDetails) {
          setDataSource(DataStore.init(viewEntity.formSsDetails));
        }
      }
    })();
  }, [props.data]);

  const handleSubmit = async (formSaId: number) => {
    FormSa.searchRevenueExpense(formSaId).then((response) => {
      setSalesDataSource(DataStore.init(response.data));
    });
  }

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `活动结案单【${entity.form?.formNo}】`;
      DataOptions.search({ typeGroup: 3, value: entity.form?.statusId }).then(response => {
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (response.data && response.data.length > 0) {
          title += `，${response.data[0].name}`;
          if (props.setPageTitle) props.setPageTitle(
            <WdiFormPageTitle
              title={title}
              onClose={props.onClose}
              callback={props.callback}
              form={entity?.form}
              useCaseId={Enum.UseCase.SS}
              moreConfig={moreConfig}
              approvalConfig={approvalConfig} />
          );
        }
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId} />
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>结案信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>)
              },
            }}
          >
            <FormSaInfosApp formRef={formRef} defaultCollapsed={true} formSaId={entity?.formSs?.formSaId} />
            <WdiPanel collapsed={true} {...props}
              title={<WdiCardTitle iconType={Enum.IconType.FORM_SS} title='活动结案单信息' />}>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={8}>
                  <Form.Item name="remark" label="活动效果说明">
                    <WdiEditor readOnly={true} />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item name="differenceDesc" label="整体差异说明">
                    <TextArea readOnly rows={4} maxLength={2000} />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList />
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          {entity?.formSs?.formSaId &&
            <SalesAndCostPanel dataSource={salesDataSource}
              collapsed={entity.form?.statusId == StatusEnum.FormStatus.AWAITING}
              onClick={async () => {
                await handleSubmit(Number(entity?.formSs?.formSaId))
              }} />
          }
          <GeneralSettleDetailsForApprovalApp
            dataSource={dataSource}
            data={{ ecFieldConfigs: entity?.ecFieldConfigs, formSs: entity?.formSs, sfaButton: entity?.sfaButton }}
            onChange={onDetailsChange} />
          {entity?.formSs?.formSsId &&
            <GeneralSettleDetailsGroupForApprovalApp formId={entity?.formSs?.formSsId} />}
        </TabPane>
        <TabPane
          tab={
            <>
              <span>警示信息</span>
              <Badge count={warningCount}
                style={{
                  color: "black",
                  boxShadow: "none",
                  background: "none",
                  top: "-20px",
                  right: "-15px",
                  position: 'absolute'
                }}>
              </Badge>
            </>
          }
          key="3"
        >
          <SsWarningApprovalApp formId={entity?.form?.formId} />
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="4">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={Enum.UseCase.SS}
            /> : <Spin/>
          }
        </TabPane>

      </Tabs>
    </>
  );
};
export default GeneralSettleApprovalApp;
